import { h } from 'vue';
import { RouterLink } from 'vue-router';
import _get from 'lodash/get';
import type { BuiTblColumn } from '@/components/bui/organisms/Tbl/types';
import TblBadge from '@/components/bui/atoms/TblBadge/TblBadge.vue';
import TblRowActions from '@/components/bui/molecules/TblRowActions/TblRowActions.vue';
import TimeFormatDateOnly from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/TimeFormatDateOnly.vue';
import UsedBy from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/UsedBy.vue';
import AlertsIndicator from '@/components/ListingPages/ItemsLister/ItemsList/FieldsRenderers/AlertsIndicator.vue';

const campaignsColumns: BuiTblColumn[] = [
  {
    key: 'alerts',
    kind: 'status',
    label: '',
    width: 64,
    render: ({ item }) =>
      Array.isArray(item.alerts) && item.alerts.length
        ? h(AlertsIndicator, { alerts: item.alerts })
        : null,
  },
  {
    key: 'name',
    kind: 'name',
    label: 'Name',
    grow: true,
    minWidth: 180,
    selectable: true,
    sortable: true,
    sortKey: 'name',
    render: ({ item }) =>
      h('div', { class: 'bui-cell-name' }, [
        h(
          RouterLink,
          { to: `/campaigns/edit/${item.id}`, class: 'title-link', onClick: (e: MouseEvent) => e.stopPropagation() },
          () => item.name,
        ),
        h('div', { class: 'bui-cell-sub' }, item.assetType ? `${item.assetType[0].toUpperCase()}${item.assetType.substring(1)}` : ''),
      ]),
  },
  {
    key: 'startDate',
    kind: 'text',
    label: 'Start Date',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'startDate',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.startDate }),
  },
  {
    key: 'endDate',
    kind: 'text',
    label: 'End Date',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'endDate',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.endDate }),
  },
  {
    key: 'usedBy',
    kind: 'usedBy',
    label: 'Used by',
    width: 80,
    render: ({ item }) => h(UsedBy, { items: item.players, label: 'Players' }),
  },
  {
    key: 'status',
    kind: 'status',
    label: 'Status',
    width: 120,
    render: ({ item }) =>
      item.isEnabled ? h(TblBadge, { tone: 'approved' }, () => 'Active') : null,
  },
  {
    key: 'modified',
    kind: 'text',
    label: 'Modified',
    grow: true,
    minWidth: 110,
    sortable: true,
    sortKey: 'dateLastModified',
    render: ({ item }) => h(TimeFormatDateOnly, { epochTime: item.dateLastModified }),
  },
  {
    key: 'organization',
    kind: 'text',
    label: 'Organization',
    grow: true,
    minWidth: 120,
    render: ({ item }) => _get(item, 'createdBy.group.name', 'None'),
  },
  {
    key: 'actions',
    kind: 'actions',
    label: 'Actions',
    width: 100,
    render: ({ item }) => h(TblRowActions, { item }),
  },
];

export default campaignsColumns;
